export default __webpack_public_path__ + "static/media/ico_more.c4c571bd.svg";